export default {
    data() {
        return {
        };
    },

    methods: {
        checkIfLicencedByKey(key) {
            if (!key) {
                return true;
            } else {
                // Split by comma and trim whitespace (needed cause sales module is for either Quotation or Contract licenses)
                const keys = key.split(",").map(k => k.trim());

                // Return true if ANY of the keys exist in LicenceString
                return keys.some(k => this.LicenceString.includes(k));
            }
        },

        checkIfFeatureEnabledByKey(key) {
            if (!key) {
                return true;
            } else if (typeof key === 'function') {
                return key(this.Features);
            } else {
                return this.Features[key];
            }
        },
    },

    computed: {
        Features() {
            return this.$store.state.GlobalSettings.Features;
        },
        LicenceString() {
            return this.$store.state.GlobalSettings.Licences;
        },
        Licenses() {
            return this.$store.getters['Licenses'];
        },
        AutoDispatchLicense() {
            return this.Licenses.AutoDispatchLicense === true ? true : false;
        },
        ContractsLicense() {
            return this.Licenses.ContractsLicense === true ? true : false;
        },
        MapsLicense() {
            return this.Licenses.MapsLicense === true ? true : false;
        },
        MultipleFirmsLicense() {
            return this.Licenses.MultipleFirmsLicense === true ? true : false;
        },
        ProPlusLicense() {
            return this.Licenses.ProPlusLicense === true ? true : false;
        },
        QuotationLicense() {
            return this.Licenses.QuotationLicense === true ? true : false;
        },
        TimeReportCalendarLicense() {
            return this.Licenses.TimeReportCalendarLicense === true ? true : false;
        },
        CheckListLicense() {
            return this.Licenses.CheckListLicense === true ? true : false;
        },
        CalendarMode() {
            return this.Licenses.CalendarMode;
        },
        CustomerPortalLicense() {
            return this.Licenses.CustomerPortalLicense === true ? true : false;
        },
        PartnerPortalLicense() {
            return this.Licenses.PartnerPortalLicense === true ? true : false;
        },
    },
}